import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './CompareButton.css';
import { NBSP } from '../../constants/symbols';

export function CompareOnboardingContent() {
  return (
    <div className={styles['onboarding-content']}>
      <Body1 color="text-inverted-default">
        Сравните этот ЖК с другими: таблица и{NBSP}выводы будут в{NBSP}избранном
      </Body1>
    </div>
  );
}
